import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
} from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';

import DialogHeader from 'components/DialogHeader';
import FilterTagsV2 from 'components/TagsV2/FilterTagsV2';
import { TagInterface } from 'store/reducers/tags';
import { IFiltersOptions } from 'types';

type ModalFiltersProps = {
  open: boolean;
  onClose: () => void;
  onFilter: (filters: IFiltersOptions[]) => void;
  selectedTags: TagInterface[];
  onTagsChange: (tags: TagInterface[]) => void;
  selectedBlockedStatus: 'BLOCKED' | 'UNBLOCKED' | null;
  onBlockedStatusChange: (status: 'BLOCKED' | 'UNBLOCKED' | null) => void;
};

export default function ModalFilters(props: ModalFiltersProps) {
  const {
    open,
    onClose,
    onFilter,
    selectedTags,
    onTagsChange,
    selectedBlockedStatus,
    onBlockedStatusChange,
  } = props;

  const handleApply = () => {
    const filters: IFiltersOptions[] = [];

    if (selectedTags.length > 0) {
      filters.push({
        property: 'tagIds',
        value: selectedTags.map(tag => tag.id).filter(Boolean) as string[],
        labelProperty: 'Tags',
        labelValue: selectedTags.map(tag => tag.nome).join(', '),
      });
    }

    if (selectedBlockedStatus) {
      filters.push({
        property: 'blockStatus',
        value: selectedBlockedStatus,
        labelProperty: 'Status de Bloqueio',
        labelValue:
          selectedBlockedStatus === 'BLOCKED' ? 'Bloqueados' : 'Desbloqueados',
      });
    }

    if (filters.length === 0) {
      onClear();
      return;
    }

    onFilter(filters);
    onClose();
  };

  const onClear = () => {
    onTagsChange([]);
    onBlockedStatusChange(null);
    onFilter([]);
    onClose();
  };

  const handleClear = () => {
    onClear();
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog fullWidth maxWidth="xs" open={open}>
      <DialogHeader title="Filtrar contatos" onClose={handleClose} />

      <DialogContent>
        <Box mb={2}>
          <FilterTagsV2 handleFilter={onTagsChange} values={selectedTags} />
        </Box>

        <FormControl fullWidth variant="outlined" size="small">
          <InputLabel id="blocked-status-label">Status de Bloqueio</InputLabel>
          <Select
            labelId="blocked-status-label"
            id="blocked-status-select"
            value={selectedBlockedStatus || ''}
            onChange={e =>
              onBlockedStatusChange(
                (e.target.value as 'BLOCKED' | 'UNBLOCKED') || null,
              )
            }
            label="Status de Bloqueio"
            endAdornment={
              selectedBlockedStatus ? (
                <InputAdornment position="end" style={{ marginRight: 24 }}>
                  <IconButton
                    size="small"
                    onClick={() => onBlockedStatusChange(null)}
                  >
                    <ClearIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              ) : null
            }
          >
            <MenuItem value="BLOCKED">Bloqueados</MenuItem>
            <MenuItem value="UNBLOCKED">Desbloqueados</MenuItem>
          </Select>
        </FormControl>
      </DialogContent>

      <DialogActions>
        <Button
          disabled={selectedTags.length === 0 && !selectedBlockedStatus}
          onClick={handleClear}
        >
          Limpar
        </Button>
        <Button
          disabled={selectedTags.length === 0 && !selectedBlockedStatus}
          variant="contained"
          color="primary"
          onClick={handleApply}
        >
          Aplicar filtros
        </Button>
      </DialogActions>
    </Dialog>
  );
}
